import React from "react";
import { MESSAGES, deleteElem } from "services/Client";
import { DELETE_TIMEOUT_MS } from "../NotificationJobs";

export default function useScheduleJobAutoDelete({ queryClient, deleteTimeoutsRef, timersByJobId }) {
    return React.useCallback((jobId) => {
        if (deleteTimeoutsRef.current[jobId]) return;

        const jobTimers = timersByJobId.current[jobId];

        deleteNextPollTimer(jobTimers);
        startAutoDeleteTimer(jobTimers)

        deleteTimeoutsRef.current[jobId] = setTimeout(async () => {

            await deleteElem(`${MESSAGES}/jobs/${jobId}`);

            // Refetch globale per rimuovere subito dalla lista
            queryClient.invalidateQueries([MESSAGES, 'jobs', 'all']);

            delete deleteTimeoutsRef.current[jobId];
            delete timersByJobId.current[jobId];

        }, DELETE_TIMEOUT_MS);

    }, [queryClient, deleteTimeoutsRef, timersByJobId]);
}

function deleteNextPollTimer(jobTimers) {
    if(jobTimers)
        delete jobTimers.nextPollAt;
}
function startAutoDeleteTimer(jobTimers) {
    if (jobTimers)
        jobTimers.autoDeleteIn = Date.now() + DELETE_TIMEOUT_MS;
}